<template>
  <PeppolContainer size="extra-small">
    <div v-if="isPeppolReady" class="flex flex-col gap-1.5">
      <div
        class="bg-primary-50 flex items-center gap-2 rounded border px-1 py-0.5"
      >
        <FontAwesomeIcon
          :icon="['fas', 'circle-check']"
          class="text-primary-600"
        />
        <span class="font-bold">{{ $t('attributes.active') }}</span>
      </div>
      <div
        v-if="$can('super-admin')"
        class="divide-y rounded border text-xs font-semibold"
      >
        <div
          v-for="peppol_identifier in invoiceable.peppol_identifiers"
          :key="peppol_identifier.id"
          class="p-1"
        >
          {{ peppol_identifier.identifier }}
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="isMissingBusinessInfo"
        class="mb-2 rounded border border-orange-200 bg-orange-50 p-2 text-xs text-orange-700"
      >
        <FontAwesomeIcon :icon="['fas', 'triangle-exclamation']" class="mr-1" />
        {{ $t('global.peppol.missing_business_number_or_vat') }}
      </div>
      <BaseButton
        :title="$t('button.peppol.check_peppol')"
        size="extra-small"
        icon="rotate"
        inverse-icon-order
        block
        :display-loader="sending"
        :disabled="sending || isMissingBusinessInfo"
        @click="checkPeppolInvoiceable"
      />
      <div
        v-if="notOnPeppol"
        class="bg-primary-200 mt-2 rounded border p-2 text-xs"
      >
        {{ $t('global.peppol.not_on_peppol_network') }}
        >
        <a :href="faqLink" target="_blank" class="underline">
          {{ $t('global.learn_more') }}
        </a>
      </div>
    </div>
  </PeppolContainer>
</template>

<script>
import { mapActions } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import PeppolContainer from '@c/Partner/Peppol/PeppolContainer.vue'
import { Languages } from '@/assets/enums/index.js'

export default {
  name: 'PeppolContactReadyComponent',
  components: {
    FontAwesomeIcon,
    PeppolContainer,
    BaseButton
  },
  props: {
    invoiceable: {
      type: Object,
      required: true
    },
    companyId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  emits: ['refresh-invoice'],
  data() {
    return {
      sending: false,
      notOnPeppol: null
    }
  },
  computed: {
    isPeppolReady() {
      return (
        Array.isArray(this.invoiceable?.peppol_identifiers) &&
        this.invoiceable.peppol_identifiers.length > 0
      )
    },
    isMissingBusinessInfo() {
      return (
        !this.invoiceable?.tva &&
        !this.invoiceable?.business_number &&
        !this.invoiceable?.gln_number
      )
    },
    faqLink() {
      return this.$i18n.locale === Languages.NEDERLANDS_BELGIUM
        ? 'https://portal.funeralmanager.be/support/solutions/articles/103000376351-wat-moet-ik-doen-als-de-ontvanger-niet-door-peppol-geauthenticeerd-is-'
        : 'https://portal.funeralmanager.be/support/solutions/articles/103000376233-que-faire-si-destinataire-n-est-pas-authentifi%C3%A9-peppol-'
    }
  },
  methods: {
    ...mapActions({
      processCheckPeppolInvoiceableAction: 'company/checkPeppolInvoiceable'
    }),
    checkPeppolInvoiceable() {
      this.sending = true
      this.processCheckPeppolInvoiceableAction({
        params: {
          model_type: this.invoiceable.type,
          model_id: this.invoiceable.id,
          company_id: this.companyId
        }
      })
        .then((response) => {
          if (response.success) {
            this.$emit('refresh-invoice')
          } else {
            this.notOnPeppol = true
            this.$h.toastWarning(response.message)
          }
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>
